import React, { useState } from "react";

const CodeBlock = ({ examples, title }) => {
  const languages = Object.keys(examples);
  const [activeTab, setActiveTab] = useState(languages[0]);
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(examples[activeTab]).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div className="dev-code-block">
      {title && <div className="dev-code-title">{title}</div>}
      <div className="dev-code-tabs">
        {languages.map(lang => (
          <button
            key={lang}
            type="button"
            className={`dev-code-tab${activeTab === lang ? " active" : ""}`}
            onClick={() => setActiveTab(lang)}
          >
            {lang}
          </button>
        ))}
        <button type="button" className="dev-code-copy" onClick={handleCopy}>
          {copied ? "Copied!" : "Copy"}
        </button>
      </div>
      <pre className={`dev-code-pre language-${activeTab}`}>
        <code>{examples[activeTab]}</code>
      </pre>
    </div>
  );
};

export default CodeBlock;
